function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 .1h22.9v3H0zM0 5h18.1v3H0zM0 10h20.3v3H0zM0 14.9h14.7v3H0zM0 19.8h21.1v3H0z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22.9 22.9"
  }, props), _ref);
};

export default SvgComponent;